import { config, captureException } from '@xingternal/hops';
import { dispatchableFetch } from '@xingternal/hops-redux';

import {
  submittingProcessingErrors,
  submittingEnd,
  submittingStart,
  submittingSuccess,
  submittingValidationErrors,
} from '../state/actions';

const { apiBaseUrl } = config;

const submitForm = (fields) =>
  dispatchableFetch({
    url: `${apiBaseUrl}/contact`,
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ contact: fields }),
    onStart: submittingStart,
    onEnd: submittingEnd,
    onSuccess: ({ emailAttached }) => submittingSuccess(emailAttached),
    onError: ({ response: { status }, jsonResponse }) => {
      switch (status) {
        case 422:
          // there might be other reasons for a 422 status code (UTEC-680)
          if (!jsonResponse.errors) {
            captureException(new Error('Unprocessable Entity exception in submit form'));

            return submittingProcessingErrors();
          }
          return submittingValidationErrors(jsonResponse.errors);
        default:
          return submittingProcessingErrors();
      }
    },
  });

export default submitForm;
